import React, { PureComponent } from 'react';
import { ButtonToolbar, FormGroup, Label, Alert } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import renderInputField from '../formFields/Input';
import { validate, sanitazeMessage } from '../../utils/form';
import renderRadioButtonField from '../formFields/RadioButton';

class CreateAppForm extends PureComponent {
  render() {
    const { handleSubmit, submitting, adding, errorMessage } = this.props;

    const createAppButton = (
      <button
        className="btn btn-primary"
        color="primary"
        onClick={handleSubmit}
        disabled={adding || submitting}
      >
        Add
      </button>
    );

    return (
      <div className="content-container">
        {errorMessage && (
          <Alert color="danger">{sanitazeMessage(errorMessage)}</Alert>
        )}
        <div className="page-title">Add a new app</div>
        <div className="page-subtitle">
          To start, choose a platform and enter a name for your app
        </div>
        <form className="form form--add-app" onSubmit={handleSubmit}>
          <div className="form__form-group app-platform">
            <FormGroup>
              <Label className="form__form-group-label">Platform:</Label>
              <Field
                name="platform"
                component={renderRadioButtonField}
                label="Android"
                radioValue="Android"
              />
              <Field
                name="platform"
                component={renderRadioButtonField}
                label="IOS"
                radioValue="IOS"
              />
              <Field
                name="platform"
                component={renderRadioButtonField}
                label="Web"
                radioValue="Web"
              />
            </FormGroup>
          </div>
          <div className="form__form-group app-url">
            <Label className="form__form-group-label">URL:</Label>
            <FormGroup check inline>
              <Field
                inline
                name="url"
                component={renderInputField}
                type="text"
                placeholder="Your app url here"
              />
            </FormGroup>
          </div>
          <div className="form__form-group app-name">
            <FormGroup>
              <Label className="form__form-group-label">Name:</Label>
              <FormGroup check inline>
                <Field
                  name="appName"
                  component={renderInputField}
                  type="text"
                  placeholder="Your app name here"
                />
                <ButtonToolbar className="form__button-toolbar">
                  {createAppButton}
                </ButtonToolbar>
              </FormGroup>
            </FormGroup>
          </div>
          <div className="create-app-button">{createAppButton}</div>
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'CreateAppForm',
  validate,
  touchOnBlur: false
})(CreateAppForm);



// WEBPACK FOOTER //
// ./src/components/createApp/CreateAppForm.js